import { useCallback, useEffect, useState } from 'react';

export default function useCanvaConnection() {
  const [connected, setConnected] = useState(false);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const res = await fetch('/api/integrations/canva/status', {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setConnected(!!data.connected);
      }
    } catch (err) {
      console.error('Failed to fetch Canva status', err);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const connect = async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const res = await fetch('/api/integrations/canva/connect', {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });
      if (!res.ok) {
        throw new Error(`Failed to start Canva connection (${res.status})`);
      }
      const data = await res.json().catch(() => ({}));
      if (!data?.redirectUrl) {
        throw new Error('Missing Canva redirect URL');
      }
      window.location.href = data.redirectUrl;
    } catch (err) {
      console.error('Failed to start Canva connection', err);
    }
  };

  const disconnect = async () => {
    const token = localStorage.getItem('token');
    try {
      await fetch('/api/integrations/canva/disconnect', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
      setConnected(false);
    } catch (err) {
      console.error('Failed to disconnect Canva', err);
    }
  };

  return { connected, refresh, connect, disconnect };
}
